// extracted by mini-css-extract-plugin
export default {"backgroundImageTop":"BackgroundImageAuthPageTopPosition_backgroundImageTop__HZzbb"};